import { IPromisePoint } from "./IMediaToolkit";

export enum EAge {
    'General' = 'General',
    '0-24 Months' = '0-24 months',
    '18-24 Months' = '0-24 months',
    '2-5 Years' = '2-5 years',
    '6-12 Years' = '6-12 years',
    '13-18 Years' = '13-18 years',
    'Adult' = 'Adult',
}

export interface ICustomPoint extends IPromisePoint {
    title: string;
    topicId: number;
    promiseId: number;
}

export interface IFamilyMember {
    name: string;
    age: EAge | null;
    avatar: number;
    pointsSelected: (number)[];
    pointsRemoved: (number)[];
    key?: string;
}

export default interface IFamily {
    name: string;
    members: IFamilyMember[];
    customPoints: ICustomPoint[];
    priorities: number[];
}
